module.exports = {
  invoice_drawCollectInvoice: '开票/收票',
  invoice_queryInvoice: '发票查询',
  invoice_invoiceCategory: '发票种类',
  invoice_invoiceDownloadLabel: '下载',
  invoice_electronicInvoiceDownload: '电子发票下载',
  invoice_sendEmail: '发送',
  invoice_mailSend: '发送邮箱',
  invoice_sendEmailLog: '日志',
  invoice_downloadTimes: '客户下载次数',
  invoice_electronicInvoiceSendStatus: '电子发票发送状态',
  invoice_download: '下载',
  invoice_salesDepartment: '销售部门',
  invoice_opDepartment: '操作部门',
  invoice_chineseDescriptionOfGoods: '中文品名',
  invoice_englishDescriptionOfGoods: '英文品名',
  billingJob_taxRate: '税率',
  invoice_hedging: '对冲',
  invoice_selectTheHedging: '请查询并选择要对冲的',
  invoice_return: '返回',
  invoice_query: '查询',
  invoice_invoicing: '开票',
  invoice_collectInvoice: '收票',
  billingJob_billDate: '账单日期',
  invoice_confirm: '确定',
  invoice_hedgingInvoice: '对冲开票',
  invoice_hedgingCollectingInvoice: '对冲收票',
  invoice_cancelBillConfirmation: '取消账单确认',
  invoice_revenueAndExpenditureMethod: '收付方式:',
  invoice_all: '全部',
  invoice_convert: '折合',
  invoice_convert_after_tax: '不含税价折合',
  invoice_receivables: '应收',
  invoice_payables: '应付',
  invoice_feeType: '费用类型:',
  invoice_domestic: '国内',
  invoice_international: '国外',
  // invoice_invoicingMethod: '开票模式',
  invoice_charges: '费用',
  invoice_business: '业务',
  invoice_bill: '账单',
  invoice_accountStatement: '对账单',
  invoice_defaultInformation: '按默认信息开票',
  invoice_customer: '客户',
  invoice_businessNumber: '业务编号',
  invoice_consignationCompany: '委托单位',
  invoice_settlementCompany: '结算单位',
  invoice_mblNo: '主单号',
  invoice_vessel: '船名',
  invoice_voyage: '航次',
  invoice_billNo: '账单号',
  invoice_accountStatementNo: '对账单号',
  invoice_paymentApplicationNo: '付款申请号',
  // invoice_invoiceNo: '发票号',
  invoice_itemNo: '项目编号',
  invoice_bookingNo: '订舱编号',
  invoice_businessType: '业务类型',
  invoice_solicitationType: '揽货类型',
  invoice_amountRange: '金额区间',
  invoice_chargeItem: '费用名称',
  invoice_customerTypeId: '客户类型',
  invoice_businessDate: '业务日期',
  invoice_receivablesInvoicingDate: '应收开票日期',
  invoice_currency: '币种',
  invoice_operation: '操作',
  invoice_sales: '销售',
  invoice_cargoSalesId: '揽货销售',
  invoice_advanceMoneyForAnotherOrNot: '是否代垫',
  invoice_adjustedOrNot: '是否调整',
  invoice_wroteOffOrNot: '是否已核销',
  invoice_generatedBillsOrNot: '是否已生成账单',
  invoice_invoicedOrNot: '是否已开票',
  invoice_appliedForPaymentOrNot: '是否已申请付款',
  invoice_receivablesInvoicingStatus: '应收开票状态',
  invoice_payablesInvoicingStatus: '应付开票状态',
  invoice_department: '部门',
  invoice_customerLevel: '客户级别',
  invoice_settlementMethod: '结算方式',
  invoice_contactPerson: '联系人',
  invoice_businessReferenceNumber: '业务参考号',
  invoice_invoiceHeader: '开票抬头',
  closeAccountCompany: '销货单位',
  invoice_inputBy: '发票创建人',
  invoice_dateCreated: '发票创建时间',
  invoice_accrued: '已计提',
  invoice_invoicingMethod: '开票方式',
  invoice_businessStatus: '业务状态',
  invoice_feeStatus: '费用状态',
  invoice_confirmStatus: '确认状态',
  invoice_vesselAndVoyage: '船名航次',
  invoice_portOfLoading: '起运港',
  invoice_portOfDestination: '目的港',
  invoice_financialDate: '财务日期',
  invoice_domesticOrInternational: '国内国外',
  invoice_paymentType: '支付类型',
  invoice_quantity: '数量',
  invoice_taxIncludedPrice: '含税价',
  invoice_taxExcludedPrice: '不含税价',
  invoice_taxAmount: '税额',
  invoice_theAmountOfWriteOffs: '核销金额',
  invoice_amountNotWrittenOff: '未销金额',
  invoice_chargesRemarks: '费用备注',
  invoice_totalAmountNotWrittenOff: '未销金额合计',
  invoice_receivablesInvoicing: '应收开票',
  invoice_payablesInvoicing: '应付开票',
  invoice_payablesCollectInvoice: '应付收票',
  invoice_invoicingType: '开票类型',
  invoice_makeType: '发票种类',
  invoice_invoiceStatus: '发票状态',
  invoice_makePaper: '纸质发票',
  invoice_makeElectronic: '电子发票',
  invoice_consolidatedInvoice: '合并开票（按结算单位分组开票）',
  invoice_consolidatedInvoiceCollect: '合并收票（按结算单位分组收票）',
  invoice_invoicingAccordingToBusiness: '按业务开票（按结算单位分组开票）',
  invoice_invoicingAccordingToBusinessCollect: '按业务收票（按结算单位分组收票）',
  invoice_invoicingAccordingToRecords: '按记录开票（每个记录生成一张发票）',
  invoice_invoicingAccordingToRecordsCollect: '按记录收票（每个记录生成一张发票）',
  invoice_invoicingPerRecord: '每个记录生成一张发票',
  invoice_invoiceType: '发票类型',
  invoice_CollectInvoiceType: '收票类型',
  invoice_invoicingAccordingToCurrency: '分币种开票',
  invoice_invoicingAccordingToCurrencyCollect: '分币种收票',
  invoice_invoicingPerCurrency: '拆分币种开票',
  invoice_invoicingPerCurrencyCollect: '拆分币种收票',
  invoice_specifyInvoiceCurrency: '指定发票币种',
  invoice_consolidatedCurrency: '合并币种',
  invoice_invoicingCurrency: '开票币种',
  invoice_invoiceExchangeRate: '发票汇率',
  invoice_invoicingCurrencyCollect: '收票币种',
  invoice_showChargeDetails: '发票内容显示费用明细',
  invoice_invoicingAccordingToFinancialExchangeRate: '按财务汇率开票',
  invoice_invoicingAccordingToFinancialExchangeRateCollect: '按财务汇率收票',
  invoice_invoicingAccordingByBillingExchangeRate: '按账单汇率开票',
  invoice_invoicingAccordingByBillingExchangeRateCollect: '按账单汇率收票',
  invoice_generateCostInvoice: '生成成本发票',
  invoice_subTotal: '小计',
  invoice_exchangeRate: '汇率',
  invoice_alwaysInvoicing: '一直按该汇率开票',
  invoice_SplitChargeOnlyChangeQuantity: '拆分后“单价”不变，“数量”更新',
  invoice_total: '合计',
  invoice_revenueAndExpenditureType: '收付类型',
  invoice_invoicingExchangeRate: '开票汇率',
  invoice_InvoicingAmount: '开票金额',
  invoice_billBusinessNo: '账单/业务号',
  invoice_billBusinessDate: '账单/业务日期',
  invoice_accountBillBusinessDate: '对账单/账单/业务号',
  invoice_paymentNotificationAndBusiness: '付款通知/业务号',
  invoice_invoiceInformation: '发票信息',
  invoice_invoiceContent: '发票内容',
  invoice_chargeDetails: '费用明细',
  invoice_unitPrice: '单价',
  // invoice_quantity: '数量',
  invoice_amount: '金额',
  invoice_invoiceNo: '发票号码',
  invoice_invoiceDate: '开票日期',
  invoice_invoicingDate: '发票日期',
  invoice_bargeETD: '驳船开航日期',
  invoice_billPaymentNo: '付款通知号',
  invoice_proofDate: '凭证日期',
  invoice_writeOffStatus: '核销状态',
  invoice_redChargesStatus: '红冲状态',
  invoice_printOrNot: '是否打印',
  invoice_invalidOrNot: '是否作废',
  invoice_exportOrNot: '是否导出',
  invoice_invoiceApplicant: '开票申请人',
  invoice_invoiceVoider: '发票作废人',
  invoice_invoiceVoidTime: '发票作废时间',
  invoice_totalCurrency: '分币种合计',
  invoice_notWrittenOffTotalCurrency: '未核销分币种合计',
  invoice_alreadyExportOrNot: '是否已导出',
  invoice_havingInvoiceingNoOrNot: '是否有发票号',
  invoice_exportProofFinancialOrNot: '是否导出财务凭证',
  invoice_totalAmount: '金额合计',
  invoice_taxFreeAmount: '不含税额',
  invoice_customJobType: '自定义业务类型',
  invoice_userDefinedField1: '自定义字段1',
  invoice_userDefinedField2: '自定义字段2',
  invoice_userDefinedField3: '自定义字段3',
  invoice_userDefinedField4: '自定义字段4',
  invoice_containerNo: '箱号',
  invoice_voyageLine: '航线',
  invoice_separateNumber: '分单号',
  invoice_sp1: '发票联',
  invoice_sp2: '付款单位',
  invoice_sp3: '发票号码',
  invoice_sp4: '清除',
  invoice_sp5: '开票日期',
  invoice_sp6: '原币种',
  invoice_sp7: '开票币种',
  invoice_sp8: '我方银行',
  invoice_sp9: '我方账号',
  invoice_sp10: '起运地',
  invoice_sp11: '卸船港',
  invoice_sp12: '目的地',
  invoice_sp13: '开航日期',
  invoice_sp14: '到港日期',
  invoice_sp15: '开票要求',
  invoice_sp16: '船名航次',
  invoice_sp17: '展开明细',
  invoice_sp18: '合并明细',
  invoice_sp19: '货物',
  invoice_sp20: '原金额',
  invoice_sp21: '折算金额',
  invoice_sp22: '折算金额',
  invoice_sp23: '备注',
  invoice_sp24: '财务说明',
  invoice_sp25: '金额合计',
  invoice_sp26: '合计',
  invoice_sp27: '企业签章',
  invoice_sp28: '复核',
  invoice_sp29: '税务登记号',
  invoice_theLastPage: '上一张',
  invoice_theNextPage: '下一张',
  invoice_sp30: '将本次内容设置为默认开票信息',
  invoice_sp31: '费用拆分',
  invoice_back: '上一步',
  invoice_selectInvoiceNo: '选择发票号',
  invoice_next: '下一步',
  invoice_invoiceConfirmation: '确定开票',
  invoice_collectInvoiceConfirmation: '确定收票',
  invoice_save: '保存',
  invoice_print: '打印',
  invoice_printAll: '全部打印',
  invoice_CATISExport: '金税导出',
  invoice_CATISPrint: '金税打印',
  invoice_CATISInvalid: '金税作废',
  invoice_cancel: '取消',
  invoice_close: '关闭',
  invoice_view: '查看',
  invoice_forceDelete: '强制删除',
  invoice_delete: '删除',
  invoice_invalid: '作废',
  invoice_exportVATInvoice: '导出增值税发票',
  invoice_importVATInvoice: '导入增值税发票',
  invoice_applyForPayment: '申请付款',
  invoice_sp32: '百旺导出',
  invoice_billPaymentState: '付款申请状态',
  invoice_downLoad: '下载',
  invoice_BatchDownloadElectronicInvoice: '批量下载电子发票',
  invoice_UpdateInvoice: '修改发票',
  invoice_ModifyInvoiceInformation: '修改发票信息',
  invoice_recheck: '复核',
  invoice_cancelRecheck: '取消复核',
  invoice_approvedStatue: '复核状态',
  invoice_approvedBy: '复核人',
  invoice_dateApproved: '复核日期',
  invoice_incomePayDate: '收付期限',
  invoice_isExtended: '是否超期',
  invoice_incomeCostDate: '收付期限',
  invoice_incomeCostRange: '超期区间',
  invoice_sellTitle: '销货单位',
  invoice_placeOfDelivery: '收货地',
  invoice_differenceAdjustment: '差额调整',
  invoice_businessCreateDate: '业务创建日期',
  invoice_dateTo: '至',
  invoice_lockCheckBoxDate: '查询两年外数据',
  invoice_queryLotsOfData: '查询两年外数据',
  invoice_invoiceDateNotEmpty: '发票日期不能为空!',
  invoice_unlockInvoiceDateQuery: '若选的发票日期范围大于2年，会影响数据加载速度，确定查询两年外的数据吗？',
  invoice_businessDateNotEmpty: '业务日期不能为空!',
  invoice_unlockBusinessDateQuery: '若选的业务日期范围大于2年，会影响数据加载速度，确定查询两年外的数据吗？',
  invoice_actualReceiptDate: '实际收票日期',
  invoice_targetVoucherNo: '对方凭证号',
  invoice_voucherDate: '凭证日期2',
  invoice_redPunch: '红冲',
  invoice_etd: 'ETD',
  invoice_eta: 'ETA',
  invoice_notesOnReceipt: '收票备注',
  invoice_invoiceRemarks: '发票备注',
  invoice_settleDepartmentPrefix: '结算部门',
  invoice_denomination: '分币种',
  lastInvoicingDate: '最晚开票日期',
  invoice_ATD: 'ATD',
  invoice_OperationTime: '操作日期',
  invoice_updateRemark: '修改备注',
  OurBankAccountNo: '我方银行账号',
  OurBankCurrency: '我方银行币种',
  RedChargesOrNot: '是否红冲',
  revenueAndExpenditureType: '收支类型',
  InvoiceDateCreated: '发票创建日期',
  ElInvoiceSendStatus: '电子发票发送状态',
  ElInvoiceSendPlatformStatus: '电子发票发送电票平台状态',
  ElInvoiceSendEmailStatus: '电子发票发送邮箱状态',
  InvoicingByBusinessDateExchangeRate: '按业务日期汇率开票',
  InvoicingByBusinessDateExchangeRateCollect: '按业务日期汇率收票',
  InvoicingByBusinessDateExchangeRateTips: '请选择同一业务日期的费用开票！',
  existUnconfirmedStatus: '所选账单中含有 账单状态 为 “ 未确认 ” 的账单，是否继续开票',
  AutoCheckInvoicing: '自动勾选开票',
  AutoCheckInvoicingToolTips: '使用后将自动勾选接近或等于预设金额的发票金额。注：此功能不会自动开票，如需开票，请手动操作。',
  DefaultInvoicingAmount: '预设开票金额：',
  AutoCheckInvoicingAmount: '自动勾选开票金额',
  AutoCheckInvoicingDialogToolTips: '自动勾选合计金额将接近或者等于预设金额。',
  AutoSplitCharge: '自动拆分费用',
  AutoCalculateSplit: '自动计算拆分',
  AutoCalculateSplitResult: '自动拆分结果',
  IncludingTaxAmountLimit: '含税价上限：',
  AutoCheckInvoicingSuccess: '操作完成，已勾选费用折合人民币金额为：{0}元，如需修改请手动勾选调整。',
  UseAutoCheckInvoicing: '根据预设开票金额勾选费用',
  AutoAmountCanNotZero: '预设开票金额必须大于0！',
  ArMoreApForAutoCheckInvoicing: '操作完成，自动勾选费用应付金额大于应收金额，直接开票视为收票，建议手动调整。',
  invoice_invoicingAccordingToSettlementAgent: '合并开票（按结算代理分组开票）',
  invoice_invoicingAccordingToSettlementAgentCollect: '合并收票（按结算代理分组收票）',
  invoice_invoicingAccordingToTitle: '按抬头开票（每个开票抬头生成一张发票）',
  invoice_invoicingAccordingToTitleCollect: '按抬头收票（每个开票抬头生成一张发票）',
  RequestTaxControlPlatformStatus: '请求税控平台是否成功',
  GetInvoiceNumber: '获取发票号',
  NotDoInvoice: '还未在云税开票，请先开票',
  GetInvoiceNoSuccess: '正在获取发票号，请稍后查看！',
  GetInvoiceNoFail: '获取发票号失败！',
  NotDoInvoiceBwjsy: '还未在百旺金穗云开票，请先开票！',
  GetInvoiceNoSuccessBwjsy: '获取发票号成功！',
  GetInvoiceNoFailPart: '有部分获取发票号失败，请稍后再试！',
  NotInvoice: '还未开票，请先开票',
  PaperTicketPrinting: '纸票打印',
  NameOfSeller: '销货单位名称',
  CNYReceived: '已收折合CNY',
  CNYNotReceived: '未收折合CNY',
  CNYPaid: '已付折合CNY',
  CNYNotPaid: '未付折合CNY',
  InvoiceNoImport: '发票号导入',
  SpecificConstraintTypes: '特定约束类型',
  PurchaserInformation: '购买方信息',
  SellerInformation: '销售方信息',
  TypeOfTransport: '运输工具类型',
  TransportVehicleBrand: '运输工具牌号',
  Origin: '起始地',
  Destination: '到达地',
  NameOfGoodsTransported: '运输货物名称',
  ServiceOfGoodsTransported: '运输货物服务',
  FeiRedApplicationStatus: '全电红字申请状态',
  RedFlushReason: '红冲原因',
  RedApplyFail: '红字申请失败，请查看失败原因。',
  RedApplying: '红字申请已发出，请耐心等待申请成功后再进行“金税导出”操作。',
  BatchCheckNotRedStatus: '仅支持操作红冲状态的发票，请重新勾选后完成操作。',
  BatchCheckNotRedApplyInvoice: '仅支持操作未进行红字申请或申请失败的发票，请重新勾选后完成操作。',
  BatchCheckRedApplySuccessInvoice: '仅支持操作红字申请成功的发票，请重新勾选后完成操作。',
  BatchCheckRedFlushInvoice: '仅支持批量同时操作相同状态的发票，请重新勾选后完成操作。',
  BatchCheckRedFlushInvoiceType: '仅支持批量同时操作全电类型的发票，请重新勾选后完成操作。',
  BatchCheckRedFlushInvoiceTipOne: '已选中的',
  BatchCheckRedFlushInvoiceTipTwo: '票将被红冲',
  IncorrectInvoicing: '开票有误',
  SalesReturn: '销货退回',
  ServiceTermination: '服务终止',
  SalesAllowance: '销售折让',
  AllElectricInvoicing: '全电开票',
  RealPersonAuth: '实人认证已失效',
  PersonAuth: '实人认证',
  WeChatScanningAgain: '请打开税务APP，登陆界面，个人业务，扫脸登录，输入账号（手机号）后扫脸登陆，成功后即可扫码完成实人认证。',
  Certified: '已认证',
  QdWarningTip: '国家税务总局正对全电发票开具接口进行紧急调整，目前程序员们正在紧急奋战中，接口升级期间请前往国家税务网站进行开票操作，期间给您带来的不便敬请谅解。',
  FailureDescription: '请求税控平台说明',
  SelectRightInvoice: '请选择符合条件的发票！',
  ApplyRed: '红字申请',
  CancelApplyRed: '红字申请撤销',
  InvoiceNotSyncOrInvalid: '发票未同步或者已作废，无法红冲！',
  CloudStarrySkyNotSync: '未同步云星空，无法作废，请先同步！',
  VoidedSuccessfully: 'Voided successfully',
  RateChangedTip: '发票日期对应汇率发生变化，是否同步更新发票汇率？',
  RateChangedSuccess: '，发票汇率更新成功！',
  SelectReasonForRedOffsetInvoice: '请选择红冲发票原因',
  OnlyMaster: '仅主票',
  invoice_chargeCurrencyRate1: '分币种汇率1',
  invoice_chargeCurrencyRate2: '分币种汇率2',
  GetInvoiceNumberVietnam: '查询越南发票号',
  GetInvoicePdfVietnam: '下载越南发票',
  GetInvoiceStateVietnam: '查询越南发票状态',
  PaymentMethodVietnam: '越南付款方式',
  InvoiceStateVietnam: '越南发票状态',
  PleaseThanOneInvoiceMerge: '请选择一条以上的发票进行合并',
  Verification: '校验',
  InvoiceDocument: '发票文件',
  Missing: '缺失',
  StartingPleaseWaitForEmail: '开始进行发票合并执行,请等待结果邮件',
  NoExistsInTheData: '选择的数据中，不存在发票文件！'
}
